<template>
    <div class="popup-video">
        <youtube class="video-youtube" :video-id="videoData.videoId" ref="youtube" :player-vars="playerVars" @playing="playing"></youtube>
    </div>
</template>

<script>
    import Helpers from '@/tools/Helpers'
    export default {
        name: 'Video',
        data() {
            return {
				Helpers,
                player: '',
                playerVars: {
                    autoplay: 1,
                    rel: 0,
                    showinfo: 0
                }
            }
        },
        components: {
			Helpers
        },
        computed: {
            videoData() {
                return this.$store.getters['GET_POPUP_DATA'];
            }
        },
        methods: {
            playing(){}
        },
        mounted() {
			Helpers.ga().send('load','video : Отчёт с Джикия' )
        }
    }
</script>



// WEBPACK FOOTER //
// Video.vue?7eb97bd6